<template>
    <div>
        <ContentHeader path-set-type="append"   />
        <div v-show="isMask" class="mask"></div>
        <div class="content-wrapper" v-loading="loading">
            <el-row>
                <el-col :span="6" class="content-left">
                <div class="trade-container">
                    <el-card class="trade-nav-panel">
                    <div slot="header" class="clearfix">
                        <span class="panel-header">审批状态</span>
                    </div>
                    <el-menu  :default-active="menuCode"  active-text-color="#000000" text-color="#000000">
                        <el-menu-item
                        v-for="(item) in menuMap"
                        :key="item.key"
                        :index="item.key"
                        @click="clickMenu(item.key)"
                        >
                        <span slot="title">{{item.value}}</span>
                        </el-menu-item>
                    </el-menu>
                    </el-card>
                </div>
                <div class="trade-container" style="margin-top:50px;">
                    <el-card class="trade-nav-panel">
                    <div slot="header" class="clearfix">
                        <span class="panel-header">紧急收货</span>
                    </div>
                    <el-menu  :default-active="menuCode"  active-text-color="#000000" text-color="#000000">
                        <el-menu-item
                        v-for="(item) in menuMap2"
                        :key="item.key"
                        :index="item.key"
                        @click="clickMenu(item.key)"
                        >
                        <span slot="title">{{item.value}}</span>
                        </el-menu-item>
                    </el-menu>
                    </el-card>
                </div>
                </el-col>
                <el-col :span="18" class="content-right" >
                    <div class="search">
                        <el-form :inline="true" :model="searchForm" ref="searchForm" class="searchForm" >
                        <!-- <el-form-item class="item" prop="prId">
                            <el-input v-model="searchForm.prId" placeholder="PR编码" size="small"></el-input>
                        </el-form-item>
                        <el-form-item class="item" prop="prName">
                            <el-input v-model="searchForm.prName" placeholder="PR名称" size="small"></el-input>
                        </el-form-item> -->
                        <el-form-item class="item" prop="poNumber">
                            <el-input v-model="searchForm.poNumber" placeholder="PO编码" size="small" clearable></el-input>
                        </el-form-item>
                        <el-form-item class="item" prop="vendorName">
                            <el-input v-model="searchForm.vendorName" placeholder="供应商名称" size="small" clearable></el-input>
                        </el-form-item>
                        <el-form-item class="item" prop="activityName">
                            <el-input v-model="searchForm.activityName" placeholder="活动名称" size="small" clearable></el-input>
                        </el-form-item>
                        <el-form-item class="item" prop="selectBrand">
                            <el-select v-model="searchForm.selectBrand" placeholder="选择品牌" size="small" clearable>
                                <el-option
                                v-for="item in brandOptions"
                                :key="item.brandId"
                                :label="item.brandName"
                                :value="item.abiBrandCode">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <!-- <el-form-item class="item" prop="selectChannel">
                            <el-select v-model="searchForm.selectChannel" placeholder="选择渠道" size="small" clearable>
                                <el-option
                                v-for="item in channelOptions"
                                :key="item.key"
                                :label="item.value"
                                :value="item.key">
                                </el-option>
                            </el-select>
                        </el-form-item> -->
                        <el-form-item class="item-btn">
                            <el-button type="danger" size="small" @click="submitForm()">搜索</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="info" size="small" @click="resetForm()">重置</el-button>
                        </el-form-item>
                        </el-form>
                    </div>
                    <div class="card-box">
                        <div class="card is-hover-shadow" v-for="(item) in cardData" :key="item.themeDetailId" >
                            <div class="card-top"  v-if="item.gpPoDTO">
                                <div class="left-top-left request-status">
                                    <div>
                                        {{item.themeName}}
                                    </div>
                                    <div class="size-cx" v-if="(item.isEmergency == 1 && menuCode !== '03')">紧急收货</div>
                                    <div
                                        class="size-cx"
                                        :class=" {
                                            'request-status-orange' :item.receiveStatus === 300,
                                            'request-status-green' :item.receiveStatus === 500,
                                            'request-status-red' :item.receiveStatus === 400
                                        }"
                                        v-if="(menuCode !== '03'&& [300,400,500].includes(item.receiveStatus))">
                                        {{ getReceiveStatus(item.receiveStatus) }}
                                    </div>
                                </div>
                                <div class="left-top-right">
                                    <div class="size-cx" v-if="(item.receiveStatus === 500)">冲销</div>
                                    <div>PO:</div>
                                    <div>{{item.gpPoDTO.poNumber}}</div>
                                </div>
                            </div>
                            <div class="card-second"  v-if="item.gpPrDTOList">
                                <div class="second-left">
                                    <span ><span class="font-weight-bold">PR信息：</span>{{getItemInfo(item.gpPrDTOList,'pr')}}</span>
                                </div>
                                <div class="second-right">
                                    <span>收货时间：</span>
                                    <span>{{getTime(item.requestTime)}}</span>

                                </div>
                                <!-- <div class="second-left">
                                    <span >PR编码：{{item.prNumber}}</span>
                                    <span style="margin:0 15px;">|</span>
                                    <span>PR名称：{{item.gpPrDTO.prName}}</span>
                                </div>
                                <div class="second-right">
                                    <span>收货时间：</span>
                                    <span>{{getTime(item.requestTime)}}</span>

                                </div> -->
                            </div>
                            <div class="card-third"  v-if="item.gpPoDTO" >
                                <div class="third-left">
                                    <span><span class="font-weight-bold">供应商：</span></span>
                                    <span>{{item.gpPoDTO.vendorName}}</span>
                                    <!-- <div class="left-third-left">
                                        <img  class="img" src="../../assets/images/gameplan-haerbin.png" alt="">
                                        <div  class="text" style="color:#409EFF">{{item.gpPrDTO.brandName}}</div>
                                    </div>
                                    <div class="left-third-right">
                                        <img class="img" src="../../assets/images/gameplan-channl.png" alt="">
                                        <span class="text">{{getChannel(item.themeChannels,'、')}}</span>
                                    </div>       -->
                                </div>
                                <!-- <div class="third-right">
                                    <span>收货时间：</span>
                                    <span>{{getTime(item.requestTime)}}</span>
                                </div> -->

                            </div>
                            <div class="card-last"  v-if="item.gpPoDTO">
                                <div class="last-left">
                                    <div class="item-last">
                                        <span>总金额：</span>
                                        <span>{{formatPrice(item.gpPoDTO.poAmount)}}</span>
                                        <span style="margin-left:2px">元</span>
                                        <span style="margin:0 10px;">|</span>
                                    </div>
                                    <div class="item-last">
                                        <span>已收货金额：</span>
                                        <span>{{formatPrice(item.gpPoDTO.grAmount || 0)}}</span>
                                        <span style="margin-left:2px">元</span>
                                        <span style="margin:0 10px;">|</span>
                                    </div>
                                    <div class="item-last"  style="color:#cd1231;font-weight: 600;">
                                        <span>本次收货金额：</span>
                                        <span>{{formatPrice(item.receiveAmount)}}</span>
                                        <span style="margin-left:2px">元</span>
                                        <span>{{ `(${formatRatio(item.receiveAmount/item.gpPoDTO.poAmount)})` }}</span>
                                    </div>
                                    <!-- <div class="item-last" v-if="item.receiveType == '01'" style="color:#cd1231;font-weight: 600;">
                                        <span>本次收货比例：</span>
                                        <span>{{formatRatio(item.receiveRatio)}}</span>
                                        <span>（</span>
                                        <span>{{formatPrice(item.receiveAmount)}}</span>
                                        <span style="margin-left:2px">元</span>
                                        <span>）</span>
                                    </div> -->
                                </div>
                                <div class="last-right">
                                    <div class="right-btn" v-if="menuCode == '01'" @click="viewSaledetail(item)">去审批</div>
                                    <div class="right-btn" v-if="menuCode == '02'" style=" color: #cd1231;border: 1px solid #cd1231; background-color: #FFFFFF;height: 26px;line-height: 26px;" @click="viewSaledetail(item)">查看详情</div>
                                    <div class="right-btn" v-if="menuCode == '03'" style=" color: #cd1231;border: 1px solid #cd1231; background-color: #FFFFFF;height: 26px;line-height: 26px;" @click="viewSaledetail(item)">查看详情</div>
                                    <!-- <div class="right-btn" v-if="menuCode == '03'" @click="viewSaledetail(item)">去审批</div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="cardData.length == 0">
                        <!-- {{loadingText}} -->
                        <!-- style="line-height:30px;text-align: center;" -->
                        <el-empty description="暂无数据"></el-empty>
                    </div>
                    <div class="pagination" v-if="cardData.length > 0">
                        <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :total="searchForm.total"
                        :current-page="searchForm.page"
                        :page-size="searchForm.pageSize"
                        @current-change="handleCurrentChange"
                        />
                    </div>
                </el-col>
            </el-row>
        </div>
        <div v-if="isShowdialog" class="dialog">
            <Popreceipt :receiveId="receiveId" :menuCode="menuCode" @closeDialog="closeDialog"></Popreceipt>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import ContentHeader from '@/components/content-header'
    import gameplanApi from '../../api/gameplan'
    import Popreceipt from './receiptProportion-pop.vue'
    export default {
      name: 'receiptProportion-approval',
      components: {
        ContentHeader,
        Popreceipt
      },
      data () {
        return {
            searchForm: {
                prId: '', // PR编码
                prName: '', // PR名称
                activityName: '', // 活动名称
                selectBrand: '' , // 选择品牌
                selectChannel: '', // 选择渠道
                searchStatus:'', // 状态
                vendorName:'',// 供应商名称
                poNumber:'',//po编码
                page: 1,
                pageSize: 10,
                total:0,
            },
            channelOptions: [], // 渠道下拉菜单
            brandOptions: [], // 品牌下拉菜单
            cardData: [],
            isFinish: false,
            isWait: false,
            loading:true,
            loadingText: '',
            menuCode: '',
            menuMap:[
                {key:'01',value:"待审批"},
                {key:'02',value:"已通过"},
                // {key:'03',value:"紧急收货凭证"},
            ],
            menuMap2:[
                {key:'03',value:"待确认凭证"},
            ],
            isMask:false,
            isShowdialog: false,
            receiveId: ''
        }
      },
      computed: {
        ...mapGetters(['userInfo']),
      },
      watch: {},
      created () {
        this.menuCode = "01";
        this.init()
      },
      mounted () {
      },
      methods: {
        init () {
            this.getSelectChannel()
            this.getSelectBrand()
            this.getThemelist()
        },
        clickMenu (code) {
            this.menuCode = code
            this.searchForm.page = 1
            this.getThemelist()
        },
        // 金额千分
        formatPrice(price) {
            return String(price).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        // 百分比
        formatRatio(ratio) {
            let str = Number(ratio*100).toFixed(1)
            return str + "%" ;
            // return ratio * 100 + '%'
        },
        getChannel(themeChannels,sign){
            if (!themeChannels) {
                themeChannels = []
            }
            let arr = themeChannels.map((item) => {
                    return item.themeChannelEnName
                }).join(sign)
            if (arr) {
                return arr
            } else {
                return 'null'
            }
        },
        getTime (timestamp) {
        if (timestamp === 0 || timestamp == null) {
            return ''
        } else {
            var date = new Date(parseInt(timestamp)) // 时间戳为13位的话需要parseInt下
            const Y = date.getFullYear() + '-'
            const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
            const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
            // const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
            // const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
            // const s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
            return Y + M + D
        }
        },
        getThemelist () {
            let params = {
                page: this.searchForm.page,
                pageSize: this.searchForm.pageSize,
                prNumber: this.searchForm.prId,
                prName: this.searchForm.prName,
                themeName: this.searchForm.activityName,
                brandCode: this.searchForm.selectBrand,
                themeChannelScope: this.searchForm.selectChannel,
                queryReceive: this.menuCode,
                poNumber: this.searchForm.poNumber,
                vendorName: this.searchForm.vendorName
                // queryStatus: this.searchForm.searchStatus,
            }
            this.loading = true
            gameplanApi.getGamepalnReportquery(params).then(res=>{
                if (res.data.resultCode === '0') {
                    let pageData = res.data.resultData.pageInfo
                    this.searchForm.page = Number(pageData.curPage)
                    this.searchForm.total = Number(pageData.totalCounts)
                    if (res.data.resultData.themeList == null) {
                        this.cardData = []
                        this.loading = false
                        this.loadingText = '暂无数据'
                    } else {
                        this.cardData = res.data.resultData.themeList
                        this.loading = false
                        this.loadingText = ''
                    }
                } else {
                    console.log('接口error');
                }
            })
        },
        async getSelectChannel () {
            // name=gpThemeChannelMap&type=list或map
            let params = {
                name:'gpThemeChannelMap',
                type:'list'
            }
            let data =  await gameplanApi.getGamepalnChannelquery(params)
            this.channelOptions = data.data.resultData.gpThemeChannelMap
        },
        async getSelectBrand () {
            let data =  await gameplanApi.getGamepalnBrandquery()
            this.brandOptions = data.data.resultData.btmpBrandDTOList
        },
        handleCurrentChange (val) {
          this.searchForm.page = val
          this.getThemelist()
        },
        getItemInfo(gpPrDTOList,type){
            let brandInfo = []
            let prInfo = []
            if(gpPrDTOList){
                gpPrDTOList.forEach(item=>{
                let data = ''
                if(type==='pr') prInfo.push(item.prNumber+'-'+item.prName)
                else {
                    if(item.brandName&&item.subBrandName)  data = item.brandName+'-'+item.subBrandName
                    else data = item.brandName||item.subBrandName
                    if(brandInfo.indexOf(data)===-1) {
                    brandInfo.push(data)
                    }
                }
                })
            }
            if(type==='pr') return prInfo.join('、')
            else return brandInfo.join('、')
        },
        submitForm (val) {
            this.$refs.searchForm.validate((valid) => {
            if (valid) {
                this.searchForm.page = 1
                this.getThemelist()
            } else {
                return false;
            }
            });
        },
        resetForm () {
            this.$refs.searchForm.resetFields();
            this.getThemelist()
        },
        // 查看收货详情
        viewSaledetail (item) {
            // console.log(item,'item');
            this.receiveId = item.receiveId
            // this.isMask = true
            // this.isShowdialog = true
            this.$router.push(
                {
                    path:'/gameplan/receiptProportion-approval-detail',
                    query: {
                         'themeId':item.themeId,
                         'themeStatus':item.themeStatus,
                         'receiveId':item.receiveId,
                        //  'routerType':this.searchForm.searchStatus
                        'menuCode':this.menuCode
                    }
                }
            )
        },
        closeDialog () {
            this.receiveId = ''
            this.isMask = false
            this.isShowdialog = false
        },
        getReceiveStatus(receiveStatus){
            if(receiveStatus===300) return 'Prime审批中'
            else if(receiveStatus===400) return 'Prime收货失败'
            else if(receiveStatus===500) return 'Prime收货成功'
        }
      }
    }
</script>
<style lang="scss" scoped>
    .el-menu-item.is-active {
        // color: #fff;
        border: none;
        font-weight: bold;
        // background-color: rgba(51, 51, 51, 0.2) !important;
    }
    .is-hover-shadow:hover {
    box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.2);
    }
    .trade-nav-panel {
      width: 80%;
    //   min-height: 400px;
      margin: 0 auto;
      background: $base-white;
    //   .el-menu-item:last-child{
    //     border-bottom: 0;
    //   }
      ::v-deep .el-card__header {
        height: 70px;
        line-height: 35px;
      }

      ::v-deep .el-card__body {
        padding: 0;
      }

      .panel-header {
        font-size: 16px;
        font-weight: 700;
        color:#CD1231;
      }
      ::v-deep .el-menu {
        border-right: 0;
      }
      ::v-deep .el-menu-item {
        border-bottom: 1px solid $base-grey5;
      }

      ::v-deep .el-menu-item.is-active {
        color: $base-red;
      }
    }
    .content-wrapper {
      min-height: calc(100vh - 320px) !important;
      font-family: SourceHanSansSC-regular;
      .content-right {
        height: 100%;
        box-sizing: border-box;
        a {
          text-decoration: none;
          color: #000;
        }
        .search {
            .searchForm {
                width: 100%;
                .item {
                    width:120px;
                }
                .item-btn {
                    margin-left: 30px;
                }
            }
        }
        .card-box {
            .card {
                width: 880px;
                padding: 10px 10px;
                background-color: #FFFFFF ;
                border-radius: 8px;
                font-size: 14px;
                margin-bottom: 20px;
                text-align: left;
                color: #101010;
                .card-top {
                    line-height: 27px;
                    font-weight: 600;
                    font-size: 20px;
                    display: flex;
                    justify-content: space-between;
                    .left-top-left {
                        flex: 1;
                        display: flex;
                        word-wrap: break-word;
                        word-break: normal;
                        word-break: break-all;
                        .size-cx {
                            padding: 0px 10px;
                            height: 20px;
                            line-height: 20px;
                            margin-top: 3.5px;
                            color: #101010;
                            background-color: #ffff00;
                            border-radius: 4px;
                            font-size: 12px;
                            font-weight: 500;
                            text-align: center;
                            margin-left: 10px;
                        }
                        // .color-orange{
                        //   border:1px solid rgb(243, 141, 74);
                        //   color:rgb(243, 141, 74);
                        //   height: 18px;
                        //   line-height: 18px;
                        //   background-color: rgba(0, 0, 0, 0) !important;
                        // }
                    }
                    .left-top-right {
                        line-height: 27px;
                        color: #CD1231 ;
                        font-size: 16px;
                        font-weight: 600;
                        display: flex;
                        justify-content: flex-end;
                        .size-cx {
                            // min-width: 37px;
                            padding: 0px 10px;
                            height: 20px;
                            line-height: 20px;
                            margin-top: 3.5px;
                            color: #FFFFFF;
                            background-color: #BED9FF;
                            border-radius: 4px;
                            font-size: 12px;
                            font-weight: 500;
                            text-align: center;
                            margin-right: 3px;
                        }
                    }
                }
                .card-second {
                    font-size: 14px;
                    line-height: 20px;
                    margin-top: 5px;
                    display: flex;
                    justify-content: space-between;
                    .second-left {
                        flex: 1;
                    }
                    .second-right {
                        color: #999999 ;
                        text-align: right;
                    }
                }
                .card-third {
                    font-size: 14px;
                    line-height: 20px;
                    margin-top: 5px;
                    display: flex;
                    justify-content: space-between;
                    .third-left {
                        display: flex;
                        justify-content: flex-start;
                        flex: 1;
                        .left-third-left {
                            margin-right: 20px;
                            display: flex;
                            justify-content: flex-start;
                            color: #539EFE;
                            .img {
                                width: 20px;
                                margin-right: 3px;
                                height: 20px;
                            }
                        }
                        .left-third-right {
                            display: flex;
                            justify-content: flex-start;
                            flex: 1;
                            .img {
                                width: 20px;
                                margin-right: 3px;
                                height: 20px;
                            }
                            .text {
                                margin: 0px 3px 0px 3px ;
                                color: #EDB60A;
                            }
                        }
                    }
                    .third-right {
                        color: #999999 ;
                        text-align: right;
                    }
                }
                .card-last {
                    font-size: 14px;
                    line-height: 28px;
                    color: #999999 ;
                    margin-top: 5px;
                    display: flex;
                    justify-content: space-between;
                    .last-left {
                        display: flex;
                        flex: 1;
                        .item-last {
                            line-height: 28px;
                        }
                    }
                    .last-right {
                        .right-btn {
                            width: 84px;
                            height: 28px;
                            line-height: 28px;
                            border-radius: 4px;
                            color: #FFFFFF;
                            background-color: #CD1231;
                            text-align: center;
                            cursor: pointer;
                        }
                    }
                }
            }
        }
        .pagination {
            position: relative;
            bottom: 0;
            text-align: center;
        }
      }
      .content-left {
        padding-right: $content-middle;
      }
    }
.mask{
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0,0,0,.7) ;
    z-index: 3;
}
.dialog {
    position: fixed;
    top: 15%;
    // left: calc((100vw - 1000px)/2);
    left: 5%;
    width: 90%;
    padding: 0px 20px 20px 20px;
    background-color: rgb(243, 245, 249);
    border-radius: 10px;
    z-index: 3;
}
.request-status{
    .request-status-orange{
        border:1px solid rgb(243, 141, 74);
        color:rgb(243, 141, 74)!important;
        height: 18px;
        line-height: 18px;
        background-color: rgba(0, 0, 0, 0) !important;
    }
    .request-status-green{
        border:1px solid $base-green;
        color:$base-green!important;
        height: 18px;
        line-height: 18px;
        background-color: rgba(0, 0, 0, 0) !important;
    }
    .request-status-red{
        border:1px solid $base-red;
        color:$base-red!important;
        height: 18px;
        line-height: 18px;
        background-color: rgba(0, 0, 0, 0) !important;
}
}
</style>
